
/**
 * Created by zhengyongbo on 17/8/17.
 */
export const SET_OPENID='SET_OPENID'
export const SET_LOGIN='SET_LOGIN'

export const SET_USERINFO='SET_USERINFO'
export const UPDATE_USERINFO='UPDATE_USERINFO'
export const SET_FIGURE='SET_FIGURE'
export const SET_PHONE_NUM='SET_PHONE_NUM'

export const SET_COMPANY_ID='SET_COMPANY_ID'
export const SET_COMPANY_LIST='SET_COMPANY_LIST'

export const SET_AUTHORITY='SET_AUTHORITY'

export const SET_AUTHREADY='SET_AUTHREADY'

export const SET_MENU_COLLAPSE='SET_MENU_COLLAPSE'

export const SET_MENU_CODE = 'SET_MENU_CODE'
